import { IonSkeletonText } from '@ionic/react';

const PlaceholderClinicForm: React.FC = () => (
  <>
    <IonSkeletonText
      animated
      style={{ width: '100%', height: '53px', marginBottom: '20px' }}
    />
    <IonSkeletonText animated style={{ width: '100%', height: '70px' }} />
  </>
);

export default PlaceholderClinicForm;
